import { getStorage, ref, FirebaseStorage, deleteObject, StorageReference, listAll, ListResult } from "firebase/storage";
import { FirebaseAppSingleton } from "../../cloudServices/googleFirebaseServices/FirebaseAppSingleton";

/**
 * @function deleteAllFilesInCloudStorageFolder Deletes all files in a Google Cloud Storage folder
 * @param cloudStorageFolderPathname A 'bare' pathname for Google Cloud Storage that does not include the server location, nor a filename.
 * @example 'userFiles/fQsNxGfjNkQ6xXGazLfcEg160Tq1/imageFiles/HIJ8PXp2m4IQ3oNlKQ6TN'
 * @returns {Promise<void>} A promise with no value, as this method is asynchronous
 */
export function deleteAllFilesInCloudStorageFolder(cloudStorageFolderPathname: string): Promise<void> {
  return new Promise<void>(async (resolve, reject) => {
    try {
      // get a reference to the Firebase Cloud Storage Service
      const storageService: FirebaseStorage = getStorage(FirebaseAppSingleton.getInstance().firebaseApp);

      // Create a reference to the folder from which files are to be deleted
      const folderRef: StorageReference = ref(storageService, cloudStorageFolderPathname);

      // get a list of all files in the folder
      const listResult: ListResult = await listAll(folderRef);

      // iterate through the list of files (items) and call 'delete' method to delete the file
      listResult.items.forEach(async (itemRef) => {
        await deleteObject(itemRef);
      });

    } catch (error: any) {
      reject(error);
    }
  });
}